import React from "react";
import { Link } from 'react-router-dom';
import { ROUTE } from '../../route/Route';

function errorPage() {
  return (
    <section>
      <div className="error-sec mt-3">
        <div className="container">
          <div className="error-img text-center">
          <img src="/assets/img/404error-img.png" alt="404error" />
          </div>
          <div className="back-btn-error text-center">
          <Link to={ROUTE.HOME} target="_blank" className="button--hexagon1"><span>BACK TO HOMEPAGE </span></Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export default errorPage;
